import {
	Button,
	Dialog,
	DialogTitle,
	Divider,
	Grid,
	IconButton,
	Tooltip,
	useMediaQuery,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import useRequestsTable from './RequestsTable.styles';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { FilterList } from '@mui/icons-material';
import moment from 'moment';
import 'moment/locale/es';
import useRequests from '@hooks/requests.hook';
import useAuth from '@hooks/auth.hook';
import { useSnackbar } from 'notistack';
import NoResultsImage from '@assets/NoResultRequest.svg';
import { GlobalContext } from '@utils/RequestContext';
import { parse as queryString } from 'query-string';
interface props {
	setNotFoundCorreo: React.Dispatch<React.SetStateAction<boolean>>;
	notFoundCorreo: boolean;
}
const RequestsTable = ({ setNotFoundCorreo }: props) => {
	const classes = useRequestsTable();
	const isMobile2 = useMediaQuery('(max-width:1465px)');

	const { getEmail } = useAuth();
	const { requestAutorizaciones, requestAdministraCliente } = useRequests();
	const { enqueueSnackbar } = useSnackbar();
	const { countRequest, setCountRequest, updateRequestTable, setUpdateRequestTable } =
		useContext(GlobalContext);

	const [solicitudes, setSolicitudes] = useState([] as any);
	// Colocamos la búsqueda en la query de la URL.
	const { search: searchQuery } = queryString(location.search);

	const [showModal, setShowModal] = useState({ show: false, approve: false });
	const [selectedRequest, setSelectedRequest] = useState([] as any);

	const handleClose = () => {
		setShowModal({ show: false, approve: false });
	};

	useEffect(() => {
		getData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (updateRequestTable) {
			getData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateRequestTable]);

	const getData = async () => {
		try {
			const response = (await requestAdministraCliente(
				`usuarios/solicitudes${searchQuery ? `?correo=${searchQuery}` : ''}`,
				'GET'
			)) as any;
			if (response.isError) {
				throw new Error(response.message || response.data.message);
			}
			if (response.data.data.length === 0 && searchQuery) {
				return setNotFoundCorreo(true);
			}
			const newData = response.data.data.map((i: any) => {
				return {
					...i,
					nombre: i.nombre
						.toLowerCase()
						.split(' ')
						.map((s: string) => s.charAt(0).toUpperCase() + s.substring(1))
						.join(' '),
					seleccionada: false,
				};
			});
			setSolicitudes(newData);
			setUpdateRequestTable(false);
			setCountRequest(newData.length);
		} catch (error: any) {
			setSolicitudes([]);
		}
	};

	const approveRequest = (solicitud: any) => {
		setSelectedRequest(solicitud);
		setShowModal({ show: true, approve: true });
	};

	const cancelRequest = (solicitud: any) => {
		setSelectedRequest(solicitud);
		setShowModal({ show: true, approve: false });
	};

	const onSave = async () => {
		try {
			const response = (await requestAutorizaciones('usuarios/gestion-asociacion', 'PUT', {
				usuario_aprueba: getEmail(),
				aprueba: showModal.approve,
				id: selectedRequest.id,
				tipo_aprobador: 1,
			})) as any;
			if (response.isError) {
				throw new Error(response.message);
			}
			getData();
			setSelectedRequest(null);
			handleClose();
		} catch (error: any) {
			if (error.response && error.response.data.cause) {
				enqueueSnackbar(error.response.data.cause, { variant: 'error' });
			} else if (typeof error?.message === 'string') {
				enqueueSnackbar(error.message, { variant: 'error' });
			}
		}
	};

	return (
		<div>
			<div>
				<Button
					startIcon={<FilterList />}
					className={classes.button}
					variant={'outlined'}
					sx={{
						marginTop: '20px !important',
						marginLeft: '24px !important',
						background: 'white',
						borderRadius: '37px',
						textTransform: 'none',
						border: '1px solid #E2EBF4',
						'&:hover': {
							backgroundColor: '#6868680D',
						},
						'& .MuiButton-startIcon': {
							margin: '0px 8px 0px 0px',
						},
					}}
				>
					Filtros
				</Button>
			</div>
			<div style={{ marginTop: 20 }}>
				<div
					className={classes.tablePadre}
					style={{ height: solicitudes.length > 0 ? '60vh' : '' }}
				>
					<table
						className={classes.table}
						style={{ minWidth: solicitudes.length > 0 ? 1100 : '' }}
					>
						<thead
							className={classes.thead}
							style={{ position: 'sticky', top: 0, zIndex: 100 }}
						>
							<tr>
								<th
									style={{
										paddingLeft: 30,
										textAlign: 'left',
										width: 200,
										minWidth: 200,
										maxWidth: 230,
									}}
									className={classes.th}
								>
									Fecha solicitud
								</th>
								<th
									style={{ textAlign: 'left', width: 180 }}
									className={classes.th}
								>
									Nombre usuario
								</th>
								<th
									style={{ textAlign: 'left', width: 250 }}
									className={classes.th}
								>
									Correo usuario
								</th>
								<th
									style={{ textAlign: 'left', width: 250 }}
									className={classes.th}
								>
									Razón Social
								</th>
								<th
									style={{ textAlign: 'left', width: 150 }}
									className={classes.th}
								>
									Documento
								</th>
								<th
									style={{
										width: 100,
										textAlign: 'left',
										top: '-1px',
									}}
									className={classes.th}
								>
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							{solicitudes.map((solicitud: any, key: number) => {
								return (
									<tr className={classes.tr} key={key}>
										<td
											style={{ paddingLeft: 30, textAlign: 'left' }}
											className={classes.td}
										>
											{moment(solicitud.fecha_registro.toString()).format(
												'DD-MM-YYYY'
											)}
										</td>
										<td
											style={{
												maxWidth: 180,
												paddingRight: 20,
												textAlign: 'left',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
												textOverflow: 'ellipsis',
											}}
											className={classes.td}
										>
											<Tooltip
												disableHoverListener={
													(+solicitud.nombre.length < 21 || !isMobile2) &&
													+solicitud.nombre.length < 28
												}
												placement="bottom-start"
												arrow
												classes={{
													tooltip: classes.tooltipBottomCampo,
													arrow: classes.arrowBottom,
												}}
												title={solicitud.nombre}
											>
												<a>{solicitud.nombre}</a>
											</Tooltip>
										</td>
										<td
											style={{
												maxWidth: 250,
												paddingRight: 20,
												textAlign: 'left',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
												textOverflow: 'ellipsis',
											}}
											className={classes.td}
										>
											<Tooltip
												disableHoverListener={
													(solicitud.correo.length < 30 || !isMobile2) &&
													+solicitud.correo.length < 49
												}
												placement="bottom-start"
												arrow
												classes={{
													tooltip: classes.tooltipBottomCampo,
													arrow: classes.arrowBottom,
												}}
												title={solicitud.correo}
											>
												<a> {solicitud.correo}</a>
											</Tooltip>
										</td>
										<td
											style={{
												maxWidth: 250,
												paddingRight: 20,
												textAlign: 'left',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
												textOverflow: 'ellipsis',
											}}
											className={classes.td}
										>
											<Tooltip
												disableHoverListener={
													(solicitud.razon_social.length < 30 ||
														!isMobile2) &&
													+solicitud.razon_social.length < 49
												}
												placement="bottom-start"
												arrow
												classes={{
													tooltip: classes.tooltipBottomCampo,
													arrow: classes.arrowBottom,
												}}
												title={solicitud.razon_social}
											>
												<a>{solicitud.razon_social}</a>
											</Tooltip>
										</td>
										<td style={{ textAlign: 'left' }} className={classes.td}>
											{solicitud.documento}
										</td>
										<td style={{ textAlign: 'left' }} className={classes.td}>
											<Tooltip
												placement="bottom"
												arrow
												classes={{
													tooltip: classes.tooltipBottom,
													arrow: classes.arrowBottom,
												}}
												title="Aprobar"
											>
												<IconButton
													onClick={() => approveRequest(solicitud)}
												>
													<CheckIcon
														style={{
															color: '#F05A28',
															fontSize: 21,
														}}
													/>
												</IconButton>
											</Tooltip>
											<Tooltip
												placement="bottom"
												arrow
												classes={{
													tooltip: classes.tooltipBottom,
													arrow: classes.arrowBottom,
												}}
												title="Rechazar"
											>
												<IconButton
													onClick={() => cancelRequest(solicitud)}
												>
													<CloseIcon
														style={{
															color: '#F05A28',
														}}
													/>
												</IconButton>
											</Tooltip>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
			{solicitudes.length === 0 && countRequest === 0 && (
				<div className={classes.noResultMesagge}>
					<Grid
						container
						spacing={3}
						direction="column"
						alignItems="center"
						justifyContent="center"
						style={{ marginTop: 40, paddingLeft: 0 }}
					>
						<Grid item>
							<img alt="img" height={'257px'} width={'250px'} src={NoResultsImage} />
						</Grid>
						<Grid item style={{ paddingTop: 0, paddingLeft: 0 }}>
							<p
								style={{
									color: '#1063AC',
									marginTop: '0px',
									fontSize: '20px',
									fontWeight: '700',
									fontFamily: 'Montserrat',
								}}
							>
								En el momento no hay solicitudes pendientes
							</p>
						</Grid>
					</Grid>
				</div>
			)}
			{showModal.show && (
				<>
					<Dialog
						open={showModal.show}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
						sx={{
							'& .MuiBackdrop-root': {
								backdropFilter: 'blur(3px)',
								backgroundColor: '#b7b7b730',
							},
							'& .MuiPaper-root': {
								width: '414px',
								boxShadow: 'none',
								borderRadius: '15px',
							},
						}}
					>
						<DialogTitle
							sx={{
								opacity: 1,
								fontWeight: 700,
								color: '#003C82',
								fontSize: '18px',
								textAlign: 'left',
								marginTop: '20px',
								padding: '2px 24px',
								fontFamily: 'Montserrat',
								paddingBottom: '0px !important',
							}}
							id="alert-dialog-title"
						>
							{showModal.approve ? (
								<> ¿Deseas aprobar esta solicitud?</>
							) : (
								<>¿Deseas rechazar esta solicitud?</>
							)}
							<Divider
								style={{
									width: '415px',
									marginTop: '13px',
									marginLeft: '-25px',
									marginBottom: '20px',
								}}
								orientation="horizontal"
								flexItem
							/>
							<div
								style={{
									width: '96%',
									margin: 'auto',
								}}
							>
								<Grid
									container
									spacing={2}
									alignItems={'flex-end'}
									justifyContent={'flex-end'}
								>
									<Grid
										item
										md={6}
										xs={12}
										sx={{
											marginRight: '-64px !important',
										}}
									>
										<Button
											sx={{
												opacity: 1,
												fontSize: 12,
												width: '122px',
												height: '36px',
												float: 'right',
												fontWeight: 600,
												border: '1px solid #0000001F',
												color: '#686868',
												fontFamily: 'Montserrat',
												borderRadius: '10px !important',
												textTransform: 'none',
												padding: '4px 8px',
												'&:hover': {
													backgroundColor:
														'#FFFFFF 0% 0% no-repeat padding-box !important',
												},
												background:
													'#FFFFFF 0% 0% no-repeat padding-box !important',
											}}
											onClick={handleClose}
										>
											CANCELAR
										</Button>
									</Grid>
									<Grid item md={6} xs={12}>
										<Button
											sx={{
												opacity: 1,
												fontSize: 12,
												width: '112px',
												height: '36px',
												float: 'right',
												fontWeight: 500,
												border: '1px solid #0D66B6',
												color: 'white',
												fontFamily: 'Montserrat',
												borderRadius: '10px !important',
												textTransform: 'none',
												padding: '4px 8px',
												'&:hover': {
													backgroundColor:
														'#0D66B6 0% 0% no-repeat padding-box !important',
												},
												boxShadow: '0px 1px 3px #00000029',
												background:
													'#0D66B6 0% 0% no-repeat padding-box !important',
											}}
											onClick={onSave}
										>
											ACEPTAR
										</Button>
									</Grid>
								</Grid>
							</div>
							<br />
						</DialogTitle>
					</Dialog>
				</>
			)}
		</div>
	);
};

export default RequestsTable;
